$(document).ready(function () {
  $forms = $("form[method='POST']");
  if ($forms.length) {

    var $fields = $("input, select, textarea");
    var $submitButtons = $(".submit-form");


    // Handle label styling (selectize styling handled in select-box.js)
    $fields.on("focus", function () {
      $(this).closest(".form-element").addClass("entered active");
    });

    $fields.on("blur", function () {
      if ($(this).val()) {
        $(this).closest(".form-element").removeClass("active");
      } else {
        $(this).closest(".form-element").removeClass("entered active");
      }
    });

    // This enables that when you click on the label for the textarea it changes users focus to textarea
    $("label[for='message']").click(function () {
      $("textarea[name='message']").select();
    });

    // fires when you paste or keyup
    $fields.on("paste keyup", function () {
      if ($(this).is("textarea") && $(this).hasClass("autoExpand")) $(this).autoResize();
    });

    $fields.on("change", function () {
      validateField($(this));
    });

    $submitButtons.click(function(e) {
      e.preventDefault();
      $(this).closest("form").submit();
    });

    $forms.submit(function(e) {
      e.preventDefault();

      var $form = $(this);
      $form.find(".submit-button").addClass("disabled");
      if (validateForm($form)) {
        var formID = $form.attr("id") || "NA";

        var checkBoxValues = getCheckBoxValue($forms);

        var formData = "formID=" + formID + "&" + $form.serialize() + checkBoxValues;

        $.ajax({
          type: "POST",
          url: "/webservices/form-submit.php",
          contentType: "application/json",
          data: formData,
          indexValue: {"$form": $form},
          success: function (data) {
            var $form = this.indexValue.$form;
            $form.find(".submit-form").removeClass("disabled");

            // animate the success state of the form
            if ($(".donation-page").length) {
              donationSuccessful();
            }else {
              successfulAnimate();
            }

            // send form sumbission to eventQueue for processing in GTM
            window.eventQueue = window.eventQueue || [];
            window.eventQueue.push({
              "eventType": "Form Submission",
              "formId": $form.attr("id")
            });

          },
          error: function (error) {
            var $form = this.indexValue.$form;
            $form.find(".submit-form").removeClass("disabled");
            alert("There was an error submitting this form. Please try again and contact harrison@brain.do if the problem persists.");
          }
        });
      }
    });
  }
});

function getCheckBoxValue($form) {
  var checkedVals = $form.find(":checked").map(function () {
    return $(this).val();
  }).get();
  if(checkedVals.length === 0) return "";
  var name = $form.find(":checked").data("name");
  return "&" + name + "=" + checkedVals.join();
}

function donationSuccessful() {
  var $charityMessage = $(".top-container p");
  var $thanksMessage = $(".bottom-container h2");
  var donationAmount = $("input[name='donation-amount']").val();
  var name = $("input[name='name']").val();
  var charity = $("input[name='charity-name']").val();

  $charityMessage.html("<p class='large'><strong>$" + donationAmount + "</strong> was donated to " + charity + ".</p>");
  $thanksMessage.text("Thanks, " + name + "!");
  $donationPage.addClass("submission-successful");
  startDonationCountdown();
}

function successfulAnimate() {
  $(".rainbow-bar").addClass("animate-it");
  $(".two-column-form-section .contains-form").addClass("vanish");
  $(".two-column-form-section .successful-submission").addClass("animate-success-message");
  
  $(".page-template-actual-lp .contains-form").addClass("vanish");
  $(".page-template-actual-lp .successful-submission").addClass("animate-success-message");
  
  $(".li-form-container .contains-form").addClass("vanish");
  $(".li-form-container .successful-submission").addClass("animate-success-message");
}

function validateForm($form) {
  var $fields = $form.find("input, select, textarea");
  $.each($fields, function (key, input) {
    var $input = $(input);
    validateField($input);
  });

  var $checkboxes = $form.find(':checkbox');
  if ($checkboxes.length > 0) {
    validateCheckboxes($checkboxes);
  }

  if (!$form.find(".show-error").length) return true;
}

function validateCheckboxes($checkboxes) {
  var $formelement = $checkboxes.closest(".form-element");
  if(!$formelement.attr("required")) {
    $formelement.removeClass("show-error");
    $checkboxes.attr("aria-invalid", "false");
    return;
  }
  if($checkboxes.is(":checked")) {
    $formelement.removeClass("show-error");
    $checkboxes.attr("aria-invalid", "false");
    return;
  }
  $formelement.addClass("show-error");
  $checkboxes.attr("aria-invalid", "true");
}

function validateField($field) {
  var regexes = {
    "address": /^[a-zA-Z0-9\s\.\,\(\)\/\-#]*$/,
    "any": /[\s\S]*/,
    "currency": /^\$[0-9,]*$/,
    "dateShort": /((0[1-9])|(1[0-2]))[\/]((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))/,
    "dateLong": /((0[1-9])|(1[0-2]))[\/]((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))[\/](\d{4})/,
    "email": /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    "initial": /[A-z]/,
    "name": /^[a-zA-Z\s]*$/,
    "percentage": /^\d{0,2}(\.\d{1,4})? *%?$/,
    "phone": /^[0-9]{10}$/,
    "search": /^(?!\s*$).+/,
    "years": /^\d{0,2} *(year[s]?)?$/,
    "zipCode": /^\d{5,6}(?:[-\s]\d{4})?$/
  };
  var isInvalid = false;
  var inputType = $field.attr("data-input-type");
  if (inputType === "checkbox") return;
  var value = $field.val();
  var isRequired = $field.attr("required");

  if (value || (!value && isRequired)) {
    if ($field.is("select")) {
      isInvalid = value == "";
    } else {
      isInvalid = !new RegExp(regexes[inputType]).test(value) || value == "";
    }
  }

  if (isInvalid) {
    $field.closest(".form-element").addClass("show-error");
    $field.attr("aria-invalid", "true");
  } else {
    $field.closest(".form-element").removeClass("show-error");
    $field.attr("aria-invalid", "false");
  }
}